module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-9.ecd92b34.png";